module.exports = __webpack_public_path__ + "assets/img/title-20d16519.png";